/* =====================================================
   FRAQUANE × PLAYBATTLE WISHLIST — FINAL
===================================================== */

const FW_KEY = "shopify-wishlist"; // 🔥 clé unique Playbattle
const FW_DELIMITER = ",";

/* ========= GET / SET ========= */

function fwGet() {
  try {
    const raw = localStorage.getItem(FW_KEY);
    return raw ? raw.split(FW_DELIMITER).filter(Boolean) : [];
  } catch (e) {
    return [];
  }
}

function fwSet(list) {
  if (list.length) {
    localStorage.setItem(FW_KEY, list.join(FW_DELIMITER));
  } else {
    localStorage.removeItem(FW_KEY);
  }

  document.dispatchEvent(
    new CustomEvent("shopify-wishlist:updated", {
      detail: { wishlist: list }
    })
  );
}

/* ========= TOGGLE ========= */

function fwToggle(handle) {
  if (!handle) return;

  let list = fwGet();

  if (list.includes(handle)) {
    list = list.filter(h => h !== handle);
  } else {
    list.push(handle);
  }

  fwSet(list);
  return list;
}

/* ========= HELPERS ========= */

function fwCount() {
  return fwGet().length;
}

function fwHas(handle) {
  return fwGet().includes(handle);
}

/* =====================================================
   RENDER WISHLIST (PAGE FRAQUANE)
===================================================== */

async function fwRender(container) {
  if (!container) return;

  const list = fwGet();
  container.innerHTML = "";

  if (!list.length) return;

  for (const handle of list) {
    try {
      const r = await fetch(`/products/${handle}.js`);
      if (!r.ok) continue;

      const p = await r.json();

      container.insertAdjacentHTML(
        "beforeend",
        `
        <article class="fw-card" data-fw-card>
          <a href="${p.url}" class="fw-card-link">
            <img src="${p.featured_image}" alt="${p.title}" loading="lazy">
            <h3>${p.title}</h3>
            <span class="fw-price">${(p.price / 100).toFixed(2)} €</span>
          </a>
          <button
            class="fw-remove"
            aria-label="Retirer de la wishlist"
            data-fw-remove="${handle}">
            ✕
          </button>
        </article>
        `
      );

    } catch (e) {
      console.warn("[Fraquane Wishlist] Erreur produit:", handle);
    }
  }

  container.querySelectorAll("[data-fw-remove]").forEach(btn => {
    btn.addEventListener("click", () => {
      fwToggle(btn.dataset.fwRemove);
    });
  });
}

/* =====================================================
   HANDLE EXTRACT
===================================================== */

function fwExtractHandle(el) {
  return (
    el.dataset.productHandle ||
    el.closest("[data-product-handle]")?.dataset.productHandle ||
    el.getAttribute("data-handle") ||
    el.closest(".product-card")
      ?.querySelector('a[href*="/products/"]')
      ?.getAttribute("href")
      ?.match(/\/products\/([^/?#]+)/)?.[1]
  );
}

/* =====================================================
   HEART UI
===================================================== */

function fwSyncHeart(btn, handle) {
  const active = fwHas(handle);
  btn.classList.toggle("is-active", active);
  btn.setAttribute("aria-pressed", active);
}

function fwPulse(btn) {
  btn.classList.remove("fw-pulse");
  void btn.offsetWidth;
  btn.classList.add("fw-pulse");
}

/* =====================================================
   BIND PLAYBATTLE HEARTS (NO OVERRIDE)
===================================================== */

function fwBindPlaybattleHearts() {
  document.querySelectorAll(
    "[button-wishlist], .btn-wishlist, .wishlist, .icon-wishlist"
  ).forEach(btn => {
    if (btn.dataset.fwBinded) return;
    btn.dataset.fwBinded = "1";

    const handle = fwExtractHandle(btn);
    if (!handle) return;

    fwSyncHeart(btn, handle);

    btn.addEventListener("click", () => {
      setTimeout(() => {
        fwSyncHeart(btn, handle);
        fwUpdateHeaderCounter();
      }, 50);
    });
  });
}

/* =====================================================
   HEADER COUNTER
===================================================== */

function fwUpdateHeaderCounter() {
  const count = fwCount();

  document.querySelectorAll("[data-js-wishlist-count]")
    .forEach(el => {
      el.textContent = count;
      el.toggleAttribute("hidden", count === 0);
    });
}

/* =====================================================
   GLOBAL EVENTS
===================================================== */

document.addEventListener("shopify-wishlist:updated", () => {
  document.querySelectorAll(
    "[button-wishlist], .btn-wishlist, .wishlist, .icon-wishlist"
  ).forEach(btn => {
    const handle = fwExtractHandle(btn);
    if (handle) fwSyncHeart(btn, handle);
  });

  document.querySelectorAll("[data-fw-grid]")
    .forEach(grid => fwRender(grid));

  fwUpdateHeaderCounter();
});

/* =====================================================
   INIT
===================================================== */

document.addEventListener("DOMContentLoaded", () => {

  fwBindPlaybattleHearts();
  fwUpdateHeaderCounter();

  document.querySelectorAll("[data-fw-grid]")
    .forEach(grid => fwRender(grid));

  let fwMutationTimer = 0;
  const fwWishlistSelector = "[button-wishlist], .btn-wishlist, .wishlist, .icon-wishlist";

  const fwNodeMayContainWishlist = (node) => {
    if (!node || node.nodeType !== 1) return false;
    try {
      if (node.matches && node.matches(fwWishlistSelector)) return true;
      return !!(node.querySelector && node.querySelector(fwWishlistSelector));
    } catch (e) {
      return false;
    }
  };

  const obs = new MutationObserver((mutations) => {
    let relevant = false;

    for (const mutation of mutations) {
      if (!mutation.addedNodes || !mutation.addedNodes.length) continue;
      for (const node of mutation.addedNodes) {
        if (fwNodeMayContainWishlist(node)) {
          relevant = true;
          break;
        }
      }
      if (relevant) break;
    }

    if (!relevant) return;
    clearTimeout(fwMutationTimer);
    fwMutationTimer = setTimeout(fwBindPlaybattleHearts, 120);
  });
  obs.observe(document.body, { childList: true, subtree: true });
});

/* =====================================================
   EXPORT
===================================================== */

window.FraquaneWishlist = {
  get: fwGet,
  set: fwSet,
  toggle: fwToggle,
  count: fwCount,
  has: fwHas,
  render: fwRender
};